import React from 'react';

const CompanyNames = () => {

    return (
      
        <div className='container text-center '>
            <img src="https://i.ibb.co/RPtfBzf/slack.png"
              width='99'height='57' className='mt-4 img-fluid mr-4' alt=""/>
            <img src="https://i.ibb.co/HDhC0Fw/google.png"
              width='99'height='57' className='mt-4 img-fluid mr-4 ' alt=""/>
            <img src="https://i.ibb.co/JCYBvX9/uber.png" 
              width='99'height='57' className='mt-4 img-fluid mr-4'alt=""/>
            <img src="https://i.ibb.co/VN13CsP/netflix.png" 
             width='99'height='57' className='mt-4 img-fluid mr-4'alt=""/>
            <img src='https://i.ibb.co/6sjbgqw/airbnb.png'
              width='99' height='57' className='mt-4 img-fluid mr-4'alt=''/>
        </div>
    );
};

export default CompanyNames;